module.exports = __webpack_public_path__ + "ad9a3043ceb144a4dee09fff4c26c6a7.svg";